import { gql } from '@apollo/client';

export default gql`
  mutation cancelPaymentLink($bookingReference: String!, $paymentRefId: String!) {
    cancelPaymentLink(bookingReference: $bookingReference, paymentRefId: $paymentRefId) {
      reference
      totalPriceToBePaid
      payments {
        id
        refId
        currency
        currencyRate
        reference
        externalReference
        refundAvailable
        provider
        method
        availableRefundAmount
        transactionTimestamp
        refundProcessTimestamp
        paymentStatus
        createdRevision
        isPayout
        isBalance
        isSuccessful
      }
    }
  }
`;
